import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function SiteLayout() {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <main className={`flex-1 ${isHome ? "" : "pt-16 md:pt-20"}`}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}